<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='accountBO.ajax?cmd=doAccountQueryDetails'
          :params="fullSearchData"
          bizName="车主账单明细导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import {
  driverBillList,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'linkman',
            label: '司机姓名',
          },
          {
            prop: 'mobilePhone',
            label: '司机手机',
          },
          {
            prop: 'businessNumberName',
            label: '业务类型',
          },
          {
            prop: 'amountDouble',
            label: '费用金额(单位元)',
          },
          {
            prop: 'opDate',
            label: '操作时间',
          },
          {
            prop: 'note',
            label: '备注',
          },
          {
            prop: 'orderId',
            label: '单号',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: driverBillList,
  },
};
</script>
<style lang="scss" scoped>
</style>
